import { useQuery } from 'react-query';
import {
  FicFidcTotalizersResponse,
  getFicFidcTotalizers,
} from 'src/services/wallet/ficFidcTotalizers';

interface UseFicFidcTotalizersParams {
  date: string;
  operationId: string;
  walletId: number | null;
  childOperationIds: string[];
}

export function useFicFidcTotalizers({
  date,
  operationId,
  walletId,
  childOperationIds,
}: UseFicFidcTotalizersParams) {
  const queryKey = [
    'fic-fidc-totalizers',
    'fic-fidc-followed-cockpit',
    walletId,
    operationId,
    date,
    childOperationIds,
  ] as const;

  return useQuery<FicFidcTotalizersResponse, unknown>({
    queryKey,
    queryFn: () =>
      getFicFidcTotalizers({
        date,
        operationId,
        walletId,
        childOperationIds,
      }),
    enabled: Boolean(date && operationId && walletId),
    keepPreviousData: false,
    refetchOnWindowFocus: false,
  });
}
